export const FLAG_GETTING_UNCLAIMED_CARGO_ITEMS =
  'FLAG_GETTING_UNCLAIMED_CARGO_ITEMS';
export const GET_UNCLAIMED_CARGO_ITEMS = 'GET_UNCLAIMED_CARGO_ITEMS';
export const CLEAR_UNCLAIMED_CARGO_ITEMS = 'CLEAR_UNCLAIMED_CARGO_ITEMS';
export const FLAG_LEGAL_ABANDONMENT_ACTIVITY =
  'FLAG_LEGAL_ABANDONMENT_ACTIVITY';
